import { ROOT_PATH } from '@/constants/common';

export function getDestination(currentPath: string): string {
  const pathSegments: string[] = currentPath.split('/').filter(Boolean);

  if (currentPath === ROOT_PATH) {
    return ROOT_PATH;
  }

  if (pathSegments.length > 1) {
    return '/' + pathSegments.slice(0, 1).join('/');
  }

  return currentPath;
}
